import { render, staticRenderFns } from "./LegalHistory.vue?vue&type=template&id=fe2ef326"
import script from "./LegalHistory.vue?vue&type=script&lang=js"
export * from "./LegalHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports